<!--
 * @Description: 地图找会场
 * @Autor: kangpeng
 * @Date: 2020-05-06 14:38:53
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-06-15 17:08:07
 -->
<template>
    <div class="map_wrap">
        <baidu-map
            @ready="mapReady"
            class="map"
            :center="center"
            :scroll-wheel-zoom="true"
            :zoom="zoom"
        >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-marker
                @click="handleClickMark(item,index)"
                v-for="(item,index) in points"
                :position="item.lg"
                :icon="{url: require('../../assets/img/map_img/location.png'), size: {width: 32, height: 32}}"
                :key="index"
            >
                <!-- 标点弹窗 -->
                <bm-info-window
                    :position="item.lg"
                    :show="item.isShowWindow"
                    @close="infoWindowClose(item)"
                    @open="infoWindowOpen(item)"
                >
                    <div class="window_info">
                        <div class="top_info">
                            <div class="left">
                                <span v-show="windowInfo.isDiscount" class="cheap_tag">优惠</span>
                                <span v-show="windowInfo.isVerification" class="checked_tag">认证会场</span>
                                <span
                                    @click="handleToVenueDetail(windowInfo.storeId)"
                                    class="name"
                                >{{windowInfo.storeName | ellipsis(15)}}</span>
                            </div>
                        </div>
                        <!-- <div class="address_wrap">
                        <span class="address_item">{{windowInfo.region}}</span>
                        <el-tooltip effect="dark" :content="windowInfo.address" placement="top">
                            <span class="address_item">地址 :{{windowInfo.address | ellipsis(6)}}</span>
                        </el-tooltip>
                        </div>-->
                        <div class="desc_info">
                            <div class="col">
                                <div class="item">
                                    <span class="label">会场数量 :</span>
                                    <span class="value">{{windowInfo.fieldCount}}间</span>
                                </div>
                                <div class="item">
                                    <span class="label">会场面积 :</span>
                                    <span class="value">{{windowInfo.area}}</span>
                                </div>
                            </div>
                            <div class="col">
                                <div class="item">
                                    <span class="label">会场人数 :</span>
                                    <span class="value">{{windowInfo.capacity}}人</span>
                                </div>
                                <div class="item">
                                    <span class="label">会场价格 :</span>
                                    <span
                                        style="color:#FF5722;font-weight:bold;font-size:14px"
                                        class="value"
                                    >{{windowInfo.minPrice ? (windowInfo.minPrice == '面议' ? '面议':`￥${windowInfo.minPrice}` ) : '--'}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="tag_wrap" v-if="windowInfo.tag">
                            <span
                                class="tag_item"
                                v-for="(tag,index) in windowInfo.tag.split(',').slice(0,3)"
                                :key="index"
                            >{{tag}}</span>
                        </div>
                        <span
                            @click="handleToVenueDetail(windowInfo.storeId)"
                            class="show_detail"
                        >查看详情</span>
                    </div>
                </bm-info-window>
            </bm-marker>

            <!-- 搜索地址 -->
            <!-- <bm-view style="width: 100%; height:calc(100vh - 88px); flex: 1"></bm-view> -->
            <bm-local-search
                style="display: none"
                :auto-viewport="true"
                :keyword="searchForm.name"
                @searchcomplete="handleSearchcomplete"
            ></bm-local-search>
            <!-- 圆形区域搜索 -->
            <bm-circle
                :center="currentPoint"
                :radius="searchForm.type"
                stroke-color="#ff5722"
                :stroke-opacity="0.8"
                :stroke-weight="2"
            ></bm-circle>
            <!-- 自定义控件 -->
            <bm-control class="bm-control">
                <div class="control_wrap">
                    <div class="serach_wrap">
                        <div class="title">
                            <span>指定范围</span>
                        </div>
                        <el-form :inline="true" size="mini" :model="searchForm">
                            <el-form-item>
                                <el-input
                                    v-model="searchForm.name"
                                    style="width:175px"
                                    placeholder="输入地标名称/地址"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select
                                    @change="handleSelectChange"
                                    v-model="searchForm.type"
                                    style="width:110px"
                                    placeholder="距离范围"
                                >
                                    <el-option label="1.5km" value="1000"></el-option>
                                    <el-option label="3km" value="3000"></el-option>
                                    <el-option label="5km" value="5000"></el-option>
                                    <el-option label="10km" value="10000"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="handleGetList">查询</el-button>
                            </el-form-item>
                            <div class="search_wrap" v-show="isShowSearchList">
                                <ul class="search_list">
                                    <li
                                        class="search_item"
                                        @click="handleGetLocation(item)"
                                        v-for="(item,index) in searchList"
                                        :key="index"
                                    >
                                        <i class="el-icon-location-outline icon"></i>
                                        <span class="txt">{{item.title | ellipsis(15)}}</span>
                                        <span class="address">{{item.city | ellipsis(10)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </el-form>
                    </div>
                    <div class="list_wrap">
                        <div class="top_tips">
                            <span class="go_back" @click="handleGoBack">&lt;返回会场中心</span>
                            <el-checkbox v-model="isShowCheck" @change="handleChangeSeeCheck">只看认证会场</el-checkbox>
                        </div>
                        <div class="screen_wrap">
                            <ul class="screen_list">
                                <li class="screen_item">
                                    <span class="district" @click="showDistrict = !showDistrict">
                                        {{sereenTerm.district}}
                                        <i
                                            :class="showDistrict ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
                                        ></i>
                                    </span>
                                    <el-collapse-transition>
                                        <div v-show="showDistrict" class="district_box">
                                            <div
                                                @click="handleChoose(1,item)"
                                                class="district_item"
                                                v-for="item in districtList"
                                                :key="item.id"
                                            >
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div>
                                    </el-collapse-transition>
                                </li>
                                <li class="screen_item">
                                    <span class="district" @click="showArea = !showArea">
                                        {{sereenTerm.area}}
                                        <i
                                            :class="showArea ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
                                        ></i>
                                    </span>
                                    <el-collapse-transition>
                                        <div v-show="showArea" class="area_box">
                                            <div
                                                @click="handleChoose(2,item)"
                                                class="district_item"
                                                v-for="item in areaList"
                                                :key="item.id"
                                            >
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div>
                                    </el-collapse-transition>
                                </li>
                                <li class="screen_item">
                                    <span class="district" @click="showNum = !showNum">
                                        {{sereenTerm.num}}
                                        <i
                                            :class="showNum ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
                                        ></i>
                                    </span>
                                    <el-collapse-transition>
                                        <div v-show="showNum" class="area_box">
                                            <div
                                                @click="handleChoose(3,item)"
                                                class="district_item"
                                                v-for="item in numList"
                                                :key="item.id"
                                            >
                                                <span>{{item.name}}</span>
                                            </div>
                                        </div>
                                    </el-collapse-transition>
                                </li>
                            </ul>
                        </div>
                        <div class="list_data" ref="listData">
                            <ul class="filed_list" v-if="fieldListData.length">
                                <li
                                    @click="handleClickFiledItem(filed,index)"
                                    :style="{background:filed.isScroll ? '#eee': '#fff'}"
                                    ref="filedItem"
                                    class="filed_item"
                                    v-for="(filed,index) in fieldListData"
                                    :key="index"
                                >
                                    <img class="img" :src="filed.urls[0]" alt />
                                    <div class="info">
                                        <div class="top_info">
                                            <div class="left">
                                                <span v-show="filed.isDiscount" class="cheap_tag">优惠</span>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    content="已验真场地为通过了365会议平台数据真A+级验证的标识。本场所的200+数据通过了平台现场验证。"
                                                    placement="bottom-start"
                                                >
                                                    <span
                                                        v-show="filed.isVerification"
                                                        class="checked_tag"
                                                    >认证会场</span>
                                                </el-tooltip>
                                                <el-tooltip
                                                    effect="dark"
                                                    :content="filed.storeName"
                                                    placement="top"
                                                >
                                                    <span
                                                        class="name"
                                                    >{{filed.storeName | ellipsis(12)}}</span>
                                                </el-tooltip>
                                            </div>
                                        </div>

                                        <div class="address_wrap">
                                            <span class="address_item">{{filed.region}}</span>
                                            <el-tooltip
                                                effect="dark"
                                                :content="filed.address"
                                                placement="top"
                                            >
                                                <span
                                                    class="address_item"
                                                >地址: {{filed.address | ellipsis(8)}}</span>
                                            </el-tooltip>
                                        </div>
                                        <div class="desc_info">
                                            <div class="col">
                                                <div class="item">
                                                    <span class="label">会场数量 :</span>
                                                    <span class="value">{{filed.fieldCount}}间</span>
                                                </div>
                                                <div class="item">
                                                    <span class="label">会场面积 :</span>
                                                    <span class="value">{{filed.area}}</span>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <div class="item">
                                                    <span class="label">会场人数 :</span>
                                                    <span class="value">{{filed.capacity}}人</span>
                                                </div>
                                                <div class="item">
                                                    <span class="label">会场价格 :</span>
                                                    <span
                                                        style="color:#FF5722;font-weight:bold;font-size:14px"
                                                        class="value"
                                                    >{{filed.minPrice ? (filed.minPrice == '面议' ? '面议':`￥${filed.minPrice}` ) : '--'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tag_wrap" v-if="filed.tag">
                                            <span
                                                class="tag_item"
                                                v-for="(tag,index) in filed.tag.split(',').slice(0,3)"
                                                :key="index"
                                            >{{tag}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <span
                                v-if="loadingSuccess && !fieldListData.length"
                                class="no_data"
                            >没有找到任何会场，换个区域试试看</span>
                        </div>
                    </div>
                </div>
            </bm-control>
        </baidu-map>
    </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
    props: {},
    data() {
        return {
            sereenTerm: {
                district: "南山区",
                area: "场地面积",
                num: "容纳人数"
            },
            districtList: [
                {
                    name: "南山区",
                    location: {
                        lng: 113.939531,
                        lat: 22.523721
                    },
                    id: "1"
                },
                {
                    name: "福田区",
                    location: {
                        lng: 114.059889,
                        lat: 22.530799
                    },
                    id: "2"
                },
                {
                    name: "宝安区",
                    location: {
                        lng: 113.88267,
                        lat: 22.54839
                    },
                    id: "3"
                },
                {
                    name: "龙华区",
                    location: {
                        lng: 114.013393,
                        lat: 22.64921
                    },
                    id: "4"
                },
                {
                    name: "龙岗区",
                    location: {
                        lng: 114.24105,
                        lat: 22.71687
                    },
                    id: "5"
                },
                {
                    name: "罗湖区",
                    location: {
                        lng: 114.131764,
                        lat: 22.548172
                    },
                    id: "6"
                },
                {
                    name: "盐田区",
                    location: {
                        lng: 114.236876,
                        lat: 22.556501
                    },
                    id: "7"
                },
                {
                    name: "光明新区",
                    location: {
                        lng: 113.910867,
                        lat: 22.783033
                    },
                    id: "8"
                }
            ],
            areaList: [
                {
                    name: "不限",
                    id: "1"
                },
                {
                    name: "0-100㎡",
                    id: "2"
                },
                {
                    name: "101-200㎡",
                    id: "3"
                },
                {
                    name: "201-300㎡",
                    id: "4"
                },
                {
                    name: "301-500㎡",
                    id: "5"
                },
                {
                    name: "501-1000㎡",
                    id: "6"
                },
                {
                    name: "1001-1500㎡",
                    id: "7"
                }
            ],
            numList: [
                {
                    name: "不限",
                    id: "1"
                },
                {
                    name: "10-50人",
                    id: "2"
                },
                {
                    name: "51-100人",
                    id: "3"
                },
                {
                    name: "101-200人",
                    id: "4"
                },
                {
                    name: "201-300人",
                    id: "5"
                },
                {
                    name: "301-500人",
                    id: "6"
                },
                {
                    name: "501-1000人",
                    id: "7"
                },
                {
                    name: "1000人以上",
                    id: "8"
                }
            ],
            searchForm: {
                name: "",
                type: ""
            },
            center: {
                lng: 113.939531,
                lat: 22.523721
            },
            zoom: 13,
            showDistrict: false, // 是否显示区域
            showArea: false, // 是否显示面积
            showNum: false, // 是否显示容纳人数
            loadingSuccess: false, // 列表数据是否赋值
            fieldListData: [], //筛选会场列表数据
            searchList: [], // 搜索数据
            points: [], // 多点标注
            position: {},
            isShowSearchList: true, // 是否展示搜索结果列表
            isShowWindow: false, // 是否展示弹窗信息
            isShowCheck: false, // 是否看认证会场
            prevName: "",
            currentPoint: {
                lng: 113.946397,
                lat: 22.529211
            }, // 搜索后的坐标
            windowInfo: {},
            nearby: {
                center: "深圳",
                radius: ""
            }
        };
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {
        sereenTerm: {
            handler(newVal) {
                this.points = [];
                this.getScreenList();
            },
            immediate: true,
            deep: true
        }
        // searchForm: {
        //     handler(newVal) {
        //         console.log(this.prevName, newVal.name);
        //         if (newVal.name !== this.prevName) {
        //             this.isShowSearchList = true;
        //         }
        //         this.prevName = newVal.name;
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        /**
         * @description: 点击窗体信息门店名字跳转详情
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToVenueDetail(storeId) {
            let url = this.$router.resolve({
                path: "/venueDetails",
                query: { id: storeId }
            });
            window.open(url.href);
        },

        /**
         * @description: 点击只看认证会场触发筛选
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChangeSeeCheck(val) {
            this.isShowCheck = val;
            this.getScreenList();
        },
        /**
         * @description: 返回会场中心
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleGoBack() {
            this.$router.go(-1);
        },
        /**
         * @description: 筛选事件
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleChoose(type, item) {
            if (type === 1) {
                this.sereenTerm.district = item.name;
                this.center = item.location;
                this.showDistrict = false;
            } else if (type === 2) {
                this.sereenTerm.area = item.name;
                this.showArea = false;
            } else if (type === 3) {
                this.sereenTerm.num = item.name;
                this.showNum = false;
            }
        },
        /**
         * @description: 获取筛选后的列表
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getScreenList() {
            let regexpNum = this.sereenTerm.num.replace(/[^0-9]/g, " ").trim();
            let regexpArea = this.sereenTerm.area
                .replace(/[^0-9]/g, " ")
                .trim();
            let param = {
                p: 1,
                s: 50,
                isVerification: this.isShowCheck ? 1 : 0,
                city: this.sereenTerm.district,
                minCapacity: regexpNum.split(" ")[0], //最小容纳人数
                maxCapacity: regexpNum.split(" ")[1], //最大容纳人数
                minArea: regexpArea.split(" ")[0], //最小面积
                maxArea: regexpArea.split(" ")[1] //最大面积
            };
            this.$post("/api/v1/storeWebsite/list", param)
                .then(res => {
                    if (res.code == 200) {
                        this.fieldListData = res.data;
                        this.$nextTick(() => {
                            this.scroll = new BScroll(this.$refs.listData, {
                                scrollY: true,
                                click: true,
                                mouseWheel: true,
                                preventDefault: true, //  阻止事件默认行为
                                stopPropagation: true, // 阻止事件冒泡
                                scrollbar: {
                                    fade: true
                                }
                            });
                        });
                        this.loadingSuccess = true;
                        this.fieldListData.map(item => {
                            this.$set(item, "isShowWindow", false);
                            this.$set(item, "isScroll", false);
                            this.points.push(item);
                        });
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 搜索坐标
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleSearchcomplete(val) {
            if (val) {
                this.searchList = val.Ir;
            }
        },
        /**
         * @description: 筛选后点击的地址
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleGetLocation(item) {
            this.searchForm.name = item.title;
            this.isShowSearchList = false;
            this.currentPoint = item.point;
        },
        /**
         * @description: 信息窗体关闭
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        infoWindowClose(item) {
            item.isShowWindow = false;
        },
        /**
         * @description: 信息窗体打开
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        infoWindowOpen(item) {
            item.isShowWindow = true;
        },
        /**
         * @description: 搜索距离值改变
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleSelectChange(value) {
            switch (value) {
                case "1000":
                    this.zoom = 16;
                    break;
                case "3000":
                    this.zoom = 14;
                    break;
                case "5000":
                    this.zoom = 13;
                    break;
                case "10000":
                    this.zoom = 12;
                    break;
            }
        },
        /**
         * @description: 地图加载成功
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        mapReady({ BMap, map }) {
            this.myGeo = new BMap.Geocoder();
        },
        /**
         * @description: 封装逆地址解析
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getAddrByPoint(point) {
            this.myGeo.getLocation(point, function(res) {
                this.position = point; //重新设置标注的地理坐标
                this.center = point; //将地图的中心点更改为给定的点
                // that.form.address = res.address; //记录该点的详细地址信息
                // that.form.addrPoint = point; //记录当前坐标点
            });
        },
        /**
         * @description: 距离筛选
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleGetList() {
            this.points = [];
            let distance = "";
            if (this.searchForm.type === "1000") {
                distance = 1;
            } else if (this.searchForm.type === "3000") {
                distance = 3;
            } else if (this.searchForm.type === "5000") {
                distance = 5;
            } else if (this.searchForm.type === "10000") {
                distance = 10;
            }
            let param = {
                p: 1,
                s: 50,
                distance: distance,
                latitude: this.currentPoint.lat,
                longitude: this.currentPoint.lng
            };
            this.$post("/api/v1/storeWebsite/list", param)
                .then(res => {
                    if (res.code == 200) {
                        this.fieldListData = res.data;
                        this.$nextTick(() => {
                            this.scroll = new BScroll(this.$refs.listData, {
                                scrollY: true,
                                click: true,
                                mouseWheel: true,
                                preventDefault: true, //  阻止事件默认行为
                                stopPropagation: true, // 阻止事件冒泡
                                scrollbar: {
                                    fade: true
                                }
                            });
                        });
                        this.loadingSuccess = true;
                        this.fieldListData.map(item => {
                            this.$set(item, "isShowWindow", false);
                            this.$set(item, "isScroll", false);
                            this.points.push(item);
                        });
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 点击标注点
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleClickMark(item, index) {
            this.windowInfo = item;
            item.isShowWindow = true;
            // 点击标注的点列表联动
            this.scroll.scrollToElement(
                this.$refs.filedItem[index],
                1000,
                0,
                0
            );
            this.fieldListData.map((item, idx) => {
                if (idx === index) {
                    item.isScroll = true;
                } else {
                    item.isScroll = false;
                }
            });
        },
        /**
         * @description: 点击会场列表item
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleClickFiledItem(filed, index) {
            this.zoom = 20;
            this.windowInfo = filed;
            this.center = filed.lg;
            this.points.map((item, idx) => {
                if (idx === index) {
                    item.isShowWindow = true;
                } else {
                    item.isShowWindow = false;
                }
            });
            this.fieldListData.map((item, idx) => {
                if (idx === index) {
                    item.isScroll = true;
                } else {
                    item.isScroll = false;
                }
            });
        }
    }
};
</script>

<style scoped lang="stylus">
.district_item
    border-bottom 1px solid #d5d8dc
    &:last-child
        border-bottom none
    &:hover
        color #10baaa
        transition all 0.28s ease-out
.search_wrap
    position absolute
    z-index 999
    width 250px
    background #fff
    font-size 14px
    .search_list
        .search_item
            display flex
            align-items center
            cursor pointer
            padding 5px 0
            color #666
            &:hover
                color #10baaa
                background #e1e1e1
                .address
                    color #10baaa
            .icon
                font-size 20px
                margin-right 5px
            .txt
                font-size 12px
                margin-right 5px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
            .address
                color #ccc
                font-size 12px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
.window_info
    width 300px
    height 120px
    font-size 12px
    .top_info
        display flex
        justify-content space-between
        .left
            .cheap_tag
                background #FF5722
                font-size 12px
                border-radius 4px
                color #fff
                padding 2px 4px
                margin-right 5px
            .checked_tag
                cursor pointer
                background #10baaa
                font-size 12px
                border-radius 4px
                color #fff
                margin-right 5px
                padding 2px 4px
            .name
                font-size 14px
                font-weight bold
                cursor pointer
                &:hover
                    color #10baaa
                    transition all 0.28s ease-out
        .right
            .add_to_pk
                cursor pointer
                color #10baaa
                font-size 12px
                padding 2px 4px
                border-radius 3px
                border 1px solid #10baaa
                &:hover
                    background #10baaa
                    color #fff
                    transition all 0.28s ease-out
    .address_wrap
        font-size 12px
        margin-top 5px
        display flex
        justify-content space-between
        .address_item
            width 50%
    .desc_info
        font-size 12px
        .col
            display flex
            margin-top 20px
            justify-content flex-start
            .item
                width 50%
    .tag_wrap
        margin-top 15px
        .tag_item
            padding 2px 4px
            font-size 12px
            color #10baaa
            border-radius 3px
            margin-right 6px
            border 1px solid #10baaa
    .show_detail
        cursor pointer
        position absolute
        bottom 0
        right 0
        &:hover
            color #10baaa
            transition all 0.28s ease-out
.map
    width 100%
    box-sizing border-box
    padding 10px
    background-color #e1e1e1
    height calc(100vh - 88px)
    .bm-control
        position absolute
        top 10px !important
        left 10px !important
        .control_wrap
            width 400px
            .serach_wrap
                padding 10px
                box-sizing border-box
                background-color #fff
                .title
                    font-size 14px
                    color #666
                    margin-bottom 10px
                .el-form
                    >>>.el-form-item
                        margin-bottom 10px
            .list_wrap
                width 400px
                padding 10px
                box-sizing border-box
                background-color #fff
                margin-top 20px
                .top_tips
                    display flex
                    font-size 14px
                    justify-content space-between
                    margin 10px 0
                    .go_back
                        color #10baaa
                        cursor pointer
                .screen_wrap
                    .screen_list
                        display flex
                        font-size 12px
                        .screen_item
                            flex 1
                            height 32px
                            box-sizing border-box
                            text-align center
                            line-height 32px
                            cursor pointer
                            background #f8f9fc
                            color #666
                            border 1px solid #d5d8dc
                            position relative
                            &:nth-child(2)
                                border-left none
                                border-right none
                            .district, .area, .num
                                margin-right 5px
                                &:hover
                                    color #10baaa
                                    transition all 0.28s ease-out
                            .district_box, .area_box
                                width 100%
                                background #fff
                                border 1px solid #d5d8dc
                                position absolute
                                top 35px
                                left 0
                                z-index 10000
                .list_data
                    width 100%
                    min-height 250px
                    max-height calc(100vh - 400px)
                    overflow hidden
                    margin-top 10px
                    position relative
                    .no_data
                        color #666
                        font-size 12px
                    .filed_list
                        .is_choose
                            background #eee
                        .filed_item
                            font-size 12px
                            height 120px
                            cursor pointer
                            box-sizing border-box
                            padding 10px
                            background #fff
                            border-bottom 1px solid #eee
                            margin-bottom 10px
                            display flex
                            .img
                                width 60px
                                height 60px
                                margin-right 10px
                            .info
                                width calc(100% - 60px)
                                .top_info
                                    display flex
                                    justify-content space-between
                                    .left
                                        .cheap_tag
                                            background #FF5722
                                            font-size 12px
                                            border-radius 4px
                                            color #fff
                                            padding 2px 4px
                                            margin-right 5px
                                        .checked_tag
                                            cursor pointer
                                            background #10baaa
                                            font-size 12px
                                            border-radius 4px
                                            color #fff
                                            margin-right 5px
                                            padding 2px 4px
                                        .name
                                            font-size 14px
                                            font-weight bold
                                            cursor pointer
                                    .right
                                        .add_to_pk
                                            cursor pointer
                                            color #10baaa
                                            font-size 12px
                                            padding 2px 4px
                                            border-radius 3px
                                            border 1px solid #10baaa
                                            &:hover
                                                background #10baaa
                                                color #fff
                                                transition all 0.28s ease-out
                                .address_wrap
                                    font-size 12px
                                    margin-top 5px
                                    display flex
                                    justify-content space-between
                                    .address_item
                                        width 50%
                                .desc_info
                                    font-size 12px
                                    .col
                                        display flex
                                        margin-top 5px
                                        justify-content flex-start
                                        .item
                                            width 50%
                                .tag_wrap
                                    margin-top 10px
                                    .tag_item
                                        padding 2px 4px
                                        font-size 12px
                                        color #10baaa
                                        border-radius 3px
                                        margin-right 6px
                                        border 1px solid #10baaa
</style>
